import React, { useState, useCallback, ReactNode } from 'react';
import type { ConfirmationDialogProps, ConfirmationFormItem } from '.';
import { DefaultConfirmationModalProps } from '../DefaultConfirmationScreen';
import ConfirmationDialogWrapper from './ConfirmationDialogWrapper';

export type WithConfirmationProps<T extends readonly ConfirmationFormItem<string>[]> = {
  message: ReactNode;
  children: (openCallback: () => void) => ReactNode;
} & (Omit<DefaultConfirmationModalProps, 'onConfirm'> & ConfirmationDialogProps<T>);

export function WithConfirmation<T extends readonly ConfirmationFormItem<string>[]>({
  message,
  onConfirm,
  onCancel,
  children,
  ...rest
}: WithConfirmationProps<T>) {
  const [open, setOpen] = useState(false);

  const onClickToOpen = useCallback(
    (event?: React.MouseEvent) => {
      event?.stopPropagation();
      setOpen(true);
    },
    [setOpen],
  );

  return (
    <>
      <ConfirmationDialogWrapper
        title="Confirmation Needed"
        {...rest}
        message={message}
        open={open}
        onConfirm={(event: React.MouseEvent, ...args: any[]) => {
          event?.stopPropagation();
          //@ts-expect-error
          onConfirm?.(event, ...args);
          setOpen(false);
        }}
        onCancel={(event?: React.MouseEvent) => {
          event?.stopPropagation();
          onCancel?.();
          setOpen(false);
        }}
      />
      {children(onClickToOpen)}
    </>
  );
}
